import React, { useEffect, useState } from "react";
import ExpandMoreSharpIcon from "@material-ui/icons/ExpandMoreSharp";
import "../../../app/base-style";
import { Grid, Typography } from "@material-ui/core";
import moment from "moment";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";
import { Skeleton } from "@material-ui/lab";
import { MenuItem, Select } from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { energyconsumptionService } from "../e_service/e_service";
import ChartTest from "../e_view/_e_bar-and-line-chart";
import MaterialUIPickers from "./_e_date-range-picker";
import { DownloadReports } from "./_e__download-reports";
import { DatePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import FormControl from "@material-ui/core/FormControl";
import { commonService } from "../../../../services/common.service";
import { getFormattedUsageData, getFormattedBillViewData } from "./_chart_data";
import GraphLoader from "./_graph_loader";
import {config} from '../../../../enviroment';
import { useTranslation } from "react-i18next";
import i18next from "i18next";
export const STYLED_MENU_ITEM = withStyles((theme) => ({
    root: {
        justifyContent: "flex-start !important",
        color: theme.palette.eRich?.base + " !important",
        fontSize: "0.8rem",
    },
}))(MenuItem);

export const STYLED_SELECT = withStyles((theme) => ({
    root: {
        color: theme.palette.eDark?.base,
        fontSize: "0.8rem",
        border: "1px solid ",
        borderRadius: "4px",
        borderColor: theme.palette.eLight?.base,
        padding: "3% 5%",
        justifyContent: "flex-start",
    },
    select: {
        "&:focus": {
            borderRadius: '0.25rem',
        }
    },
    icon: {
        color: theme.palette.eDark?.base,
    },

}))(Select);

const useStyle = makeStyles((theme) => ({
    chooseViewLabel: {
        color: theme.palette.eDark?.base,
        fontSize: "0.8rem",
        border: "1px solid ",
        borderRadius: "4px",
        borderColor: theme.palette.eLight?.base,
        padding: "4.15% 6.92%",
        justifyContent: "flex-start",
    },
    graphOptions: {
        flexWrap: 'inherit',
    },
    downloadUsageButton: {
        justifyContent: 'flex-end',
    },
    titile: {
        color: theme.palette.ePrimary?.base,
    },
    size: {
        paddingBottom: "0.3%"
    },
    minWidth: {
        paddingBottom: "0.3%",
        minWidth:"8rem !important"
    },
    des: {
        marginTop: "2%",
        color: theme.palette.ePrimary?.base
    },
    overlayParent: {
        position: "relative"
    },
    overlayClass: {
        position: "absolute",
        backgroundColor: theme.palette.eWhite?.base,
        opacity: 0.7,
        textAlign: "center",
        top: 0,
        left: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIindex: 10,
        height: "100%",
        width: "100%",
        fontWeight: 500,
    },
    styleWidth:{
        width:"110% !important"
    },
    dataRange:{
        color: theme.palette.eTertiary?.base + " !important",
        fontWeight: "bold",
        marginTop:"0.5rem" ,
       
         ["@media (min-width:540px)"]: {
            marginTop:"1.35rem !important"
          }}
}));

export default function ChooseViewDropdown(props) {
    const classes = useStyle();

    const {t:Labels, ready: highestUsageLabelReady} = useTranslation("label-HIGHEST_USAGE")
    const languageCode = useSelector(
        (state) =>
            state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
    );
    const isMobile = useMediaQuery({ maxWidth: 530 });
    const saId = useSelector((state) => state?.meterDetails?.getSaInfo?.saId);
    const saStartDate = useSelector((state) => state?.meterDetails?.getSaInfo?.saStartDate);
    const accountId = useSelector((state) => state?.meterDetails?.accountId);
    const {t:labels, ready: usageTrendLabelReady} = useTranslation("label-E_USAGE_TREND")
    const accountDetails = useSelector(
        (state) => state?.accountInformation?.accountDetails
    );
    const isPrepaidSa = useSelector(
        (state) => state?.meterDetails?.getSaInfo?.isPrepaidSa
    );
    let meterLogo = useSelector(
        (store) => store?.parametersWidgets?.ParameterLookup?.ELECTRICITY_PILLAR_IMAGE
    );
    let MONTHLY_CHART_DATE_FORMAT = useSelector(
        (state) => state?.parametersWidgets?.ParameterLookup?.MONTHLY_VIEW_INTERVAL_SHORTNAME_DATE_FORMAT
    );
    MONTHLY_CHART_DATE_FORMAT = MONTHLY_CHART_DATE_FORMAT ? MONTHLY_CHART_DATE_FORMAT:
    config?.EnergyConsumption?.FALLBACK_MONTHLY_CHART_DATE_FORMAT;

    const [record, setRecord] = useState(null);
    const [records, setRecords] = useState(null);
    const [customRange, setCustomRange] = useState(false);
    const [monthCustomRange, setMonthCustomRange] = useState(false);
    const [billCustomRange, setBillCustomRange] = useState(false);
    const [billView, setBillView] = useState(false);
    const [hourCustomRange, setHourCustomRange] = useState(false);
    const [weekCustomRange, setWeekCustomRange] = useState(false);
    const [datePickerIsOpen, setDatePickerIsOpen] = React.useState(false);
    const [chooseViewDropdown, setChooseViewDropdown] = useState(null);
    const [choosetimePeriodDropdown, setChoosetimePeriod] = useState(null);
    const [usageData, setUsageData] = useState(null);
    const [billData, setBillData] = useState(null);
    const [MeterImage, setMeterImage] = useState("");
    const [startDate, setStartDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);
    const [customstartDate, setCustomStartDate] = React.useState(null);
    const [customendDate, setCustomEndDate] = React.useState(null);
    const [graphLoading, setGraphLoading] = useState(false)
    const [previousAccId, setPreviouseAccId] = useState("")
    const [previouSaId, setPreviouSaId] = useState("")
    const [overlay, setOverlay] = useState(false)
    const [noDataOverlay, setNoDataOverlay] = useState(false)
    const [formattedUsageData, setFormattedUsageData] = useState({})
    const [formattedBillData, setFormattedBillData] = useState({})
    const [ddlMenuProps, setDdlMenuProps] = useState({})
    const [usageUnit, setUsageUnit] = useState("")
    const [hourlyMode, setHourlyMode] = useState("USAGE_MODE_HOURLY_LAST_24_HRS")
    const [showDateRange,setshowDateRange]=useState({});
    const YEAR_DATE_FORMAT = useSelector(
        (state) => state?.parametersWidgets?.ParameterLookup?.YEAR_DATE_FORMAT
    );
    const TIMESTAMP_DATE_FOMRAT = useSelector(
        (state) => state?.parametersWidgets?.ParameterLookup?.TIMESTAMP_DATE_FORMAT
    );
    const [totalHourlyData,setTotalHourlyData] = useState()
    useEffect(() => {
        setDdlMenuProps({
            disableScrollLock: false,
            anchorOrigin: {
                vertical: "bottom"
            },
            transformOrigin: {
                vertical: "top"
            },
            getContentAnchorEl: null,
        })
    }, [])

    useEffect(() => {
        if (meterLogo) {
            commonService.getAssestUrl(meterLogo).then((response) => {
                setMeterImage(response);
            })
                .catch((err) => {
                    setMeterImage("");
                })
        }
    }, [meterLogo]);

    useEffect(() => {
        if (i18next.language) {
            energyconsumptionService.getDropdownData("DROPDOWN_CHOOSE_VIEW", i18next.language).then((resp) => {
                if (isPrepaidSa === 'Y') {
                    setRecord(resp?.data?.getDropdownData?.filter((value) => value?.dropDownCode !== "USAGE_DROPDOWN_BILL_VIEW"));
                }
                else {
                    setRecord(resp?.data?.getDropdownData);
                }
                setChooseViewDropdown(resp?.data?.getDropdownData[0]);
                if (chooseViewDropdown?.dropDownCode === resp?.data?.getDropdownData[0]?.dropDownCode) {
                    viewChangeHandler(chooseViewDropdown?.dropDownCode);
                }
            })
                .catch((err) => {
                    setRecord(null);
                    setChooseViewDropdown(null);
                })
        }
    }, [languageCode, isPrepaidSa,i18next]);

    useEffect(() => {
        if(i18next.language){
            usageDropdownService("DROPDOWN_DAILY_VIEW_CHOOSE_TIME_PERIOD")
        }
        
    }, [languageCode,i18next.language]);

    useEffect(() => {
        if (compareSaIds()) {
            viewChangeHandler(chooseViewDropdown?.dropDownCode, true);
        }
        setCustomRange(false);
        setMonthCustomRange(false);
        setBillCustomRange(false);
        setHourCustomRange(false);
        setWeekCustomRange(false);
        setPreviouseAccId(accountId);
        setPreviouSaId(saId);
    }, [saId, accountId]);

    useEffect(() => {
        viewChangeHandler(chooseViewDropdown?.dropDownCode);
    }, [chooseViewDropdown])

    const compareSaIds = () => {
        const prevAccountDetails = accountDetails?.filter((prevAcc) => prevAcc.accountId === previousAccId)
        const prevSaDetails = prevAccountDetails?.find((prevSa) => prevSa?.saDetails?.[0]?.saId === previouSaId)
        const prevIsPrepaidSa = prevSaDetails?.saDetails?.[0]?.isPrepaidSa

        const presAccountDetails = accountDetails?.filter((presAcc) => presAcc.accountId === accountId)
        const presSaDetails = presAccountDetails?.find((presSa) => presSa?.saDetails?.[0]?.saId === saId)
        const presIsPrepaidSa = presSaDetails?.saDetails?.[0]?.isPrepaidSa

        return prevIsPrepaidSa === presIsPrepaidSa
    }
    const usageServiceGraphData = (startingDate, endingDate, dataType, additionalIdentifiers) => {
        setGraphLoading(true);
        energyconsumptionService
            .usageGraphData(saId, accountId, startingDate, endingDate, dataType, additionalIdentifiers)
            .then(async (response) => {
                setGraphLoading(false);
              let result = response?.data?.getUsageTrends?.usageQuantity;
                      let finalResult;
                      let duplicateResult = Array.from(result);
                      let hourlyView="D2BH"
                    if (
                          dataType==hourlyView
                      ) {
                     setshowDateRange({
                         startDate:duplicateResult[0].intervalShortName.split("-")[0],
                         endDate:duplicateResult[duplicateResult.length-1]?.intervalShortName.split("-")[0]
                      })
                        finalResult = Array.isArray(duplicateResult)? duplicateResult?.map((usage)=>{
                          let split = usage?.intervalShortName.split('-');
                          return {...usage,intervalShortName:split[1]};
                       }): null
                       result = finalResult;
                     }
                    let respFormattedData = getFormattedUsageData(result,chooseViewDropdown);
               
                setUsageData(response?.data);
                setFormattedUsageData(respFormattedData)
                setNoDataOverlay(respFormattedData?.noData)
                setBillView(false);
                setBillData(null);
                setFormattedBillData(null)
                if( dataType == hourlyView){
                    let tempData =0;
                    const stringArray = respFormattedData?.graphQuantity ;
                    const numberArray = stringArray.map(Number)
                    numberArray.forEach(item =>{
                        tempData += item
                    })
                    setTotalHourlyData(tempData)
                }
            })
            .catch((error) => {
                setGraphLoading(false);
                setUsageData(null);
                setBillView(false);
                setBillData(null);
                setFormattedBillData(null)
            })
    }
    useEffect(() => {
        if (usageData?.getUsageTrends?.usageUnit) {
            setUsageUnit(usageData?.getUsageTrends?.usageUnit)
        }
    }, [usageData])

    const usageBillingHistoryDetails = (endingDate, startingDate) => {
        setGraphLoading(true);
        energyconsumptionService
            .getBillingHistoryDetails(endingDate, accountId, startingDate)
            .then((resp) => {
                setGraphLoading(false);
                setBillData(resp?.data?.getBillPayHistory?.financialBillHistory?.history)
                const billDateRange = {
                    startDate: resp?.data?.getBillPayHistory?.financialBillHistory?.startDate,
                    endDate: resp?.data?.getBillPayHistory?.financialBillHistory?.endDate
                }
                let respFormattedData = getFormattedBillViewData(resp?.data?.getBillPayHistory?.financialBillHistory?.history, billDateRange, MONTHLY_CHART_DATE_FORMAT)
                setFormattedBillData(respFormattedData);
                setNoDataOverlay(respFormattedData?.noData)
                setBillView(true);
                setUsageData(null);
                setFormattedUsageData(null);
            })
            .catch((err) => {
                setGraphLoading(false);
                setBillData(null);
                setBillView(true);
                setUsageData(null);
                setFormattedUsageData(null);
            })
    }

    const handleEndDateChange = (date) => {
        setCustomEndDate(date);
        if (billCustomRange) {
            usageBillingHistoryDetails(moment(date).format("YYYY-MM-DD"), moment(customstartDate).format("YYYY-MM-DD"))
        } else {
            usageServiceGraphData(
                moment(customstartDate).format("YYYY-MM-DD"),
                moment(date).format("YYYY-MM-DD"),
                customRange ? "D2BD" : "D2BM"
            )
        }
        setOverlay(false)
    };
    const handleDateChange = (date) => {
        setCustomStartDate(date);
        if (customendDate) {
            if (billCustomRange) {
                usageBillingHistoryDetails(
                    moment(customendDate).format("YYYY-MM-DD"),
                    moment(date).format("YYYY-MM-DD"),
                )
            } else {
                usageServiceGraphData(
                    moment(date).format("YYYY-MM-DD"),
                    moment(customendDate).format("YYYY-MM-DD"),
                    customRange ? "D2BD" : "D2BM"
                )
            }
        }
        setStartDate(null)
        setEndDate(null);
    };

    const chooseViewChange = (e) => {
        let findItem = record.find(item => item.dropDownCode === e.target.value)
        setChooseViewDropdown({
            dropDownCode: e.target.value,
            dropDownValue: findItem.dropDownValue,
        });
        setshowDateRange({})
    };

    const usageDropdownService = (timePeriod, isSameAccType) => {
        energyconsumptionService
            .getDropdownData(timePeriod, i18next.language)
            .then((resp) => {
                setRecords(resp?.data?.getDropdownData);
                if (choosetimePeriodDropdown?.dropDownCode === resp?.data?.getDropdownData[0]?.dropDownCode) {
                    timePeriodChangeHandler(choosetimePeriodDropdown?.dropDownCode)
                } else {
                    if (isSameAccType) {
                        timePeriodChangeHandler(choosetimePeriodDropdown?.dropDownCode)
                    } else {
                        setChoosetimePeriod(resp?.data?.getDropdownData[0]);
                    }
                }
                setCustomStartDate(null);
                setCustomEndDate(null);
            })
            .catch((err) => {
                setRecords(null);
                setChoosetimePeriod(null);
            })
    }

    const viewChangeHandler = (value, isSameAccType) => {
        setOverlay(false)
        switch (value) {
            case "USAGE_DROPDOWN_DAILY_VIEW":
                usageDropdownService("DROPDOWN_DAILY_VIEW_CHOOSE_TIME_PERIOD", isSameAccType)
                break;
            case "USAGE_DROPDOWN_MONTHLY_VIEW":
                usageDropdownService("MONTHLY_VIEW_CHOOSE_TIME_PERIOD", isSameAccType)
                break;
            case "USAGE_DROPDOWN_WEEK_VIEW":
                usageDropdownService("WEEK_VIEW_CHOOSE_TIME_PERIOD", isSameAccType)
                break;
            case "USAGE_DROPDOWN_HOUR_VIEW":
                usageDropdownService("HOUR_VIEW_CHOOSE_TIME_PERIOD", isSameAccType)
                break;
            case "USAGE_DROPDOWN_BILL_VIEW":
                usageDropdownService("BILL_VIEW_CHOOSE_TIME_PERIOD", isSameAccType)
                break;
        }
    }

    const handleStateChanges = (tCustomRange, tMonthCustomRange, tBillCustomRange, tBillView, tOverlay, tStartDate, tEndDate) => {
        setCustomRange(tCustomRange);
        setMonthCustomRange(tMonthCustomRange);
        setBillCustomRange(tBillCustomRange);
        setOverlay(tOverlay);
        if (tStartDate && tEndDate) {
            setStartDate(tStartDate)
            setEndDate(tEndDate)
        }
        if (!tCustomRange) {
            setCustomStartDate(null)
            setCustomEndDate(null)
        }
        if (tCustomRange) {
            setStartDate(null)
            setEndDate(null)
        }
    }

    const timePeriodChange = (event) => {
        setChoosetimePeriod({
            dropDownCode: event.target.value,
            dropDownValue: event.target.name,
        });
        setshowDateRange({})
    }

    useEffect(() => {
        timePeriodChangeHandler(choosetimePeriodDropdown?.dropDownCode)
    }, [choosetimePeriodDropdown])

    const timePeriodChangeHandler = (value) => {
        let current = new Date();
        switch (value) {
            case "DAILY_CHOOSE_TIME_PERIOD_LAST_30_DAYS": {
                let tempEndDate = moment(current).format("YYYY-MM-DD");
                let tempStartDate = moment()
                    .add(-30, "days")
                    .format("YYYY-MM-DD");
                handleStateChanges(false, false, false, false, false, tempStartDate, tempEndDate)
                usageServiceGraphData(tempStartDate, tempEndDate, "D2BD");
                break;
            }
            case "DAILY_CHOOSE_TIME_PERIOD_LAST_WEEK": {
                let tempEndDate = moment(current).format("YYYY-MM-DD");
                let tempStartDate = moment()
                    .add(-6, "days")
                    .format("YYYY-MM-DD");
                handleStateChanges(false, false, false, false, false, tempStartDate, tempEndDate)
                usageServiceGraphData(tempStartDate, tempEndDate, "D2BD");
                break;
            }
            case "DAILY_CHOOSE_TIME_PERIOD_YESTERDAY": {
                const tempEndDate = moment(current).subtract(1,'day').endOf('day').format(YEAR_DATE_FORMAT);
                const tempStartDate = moment(current)
                    .subtract(1, 'day').startOf('day')
                    .format(YEAR_DATE_FORMAT);
                    setHourCustomRange(false);
                setWeekCustomRange(false)
                let startDateForYesterday = moment(tempStartDate).subtract(1,'day').format(YEAR_DATE_FORMAT)
                handleStateChanges(false, false, false, false, false, startDateForYesterday, tempEndDate);
                usageServiceGraphData(tempStartDate, tempEndDate, "D2BD");
                break;
            }
            case "DAILY_CHOOSE_TIME_PERIOD_CURRENT_MONTH": {
                const tempEndDate = moment()
                    .endOf("month")
                    .format("YYYY-MM-DD");
                const tempStartDate = moment()
                    .startOf("month")
                    .format("YYYY-MM-DD");
                handleStateChanges(false, false, false, false, false, tempStartDate, tempEndDate);
                usageServiceGraphData(tempStartDate, tempEndDate, "D2BD");
                break;
            }
            case "DAILY_CHOOSE_TIME_PERIOD_CUSTOM_RANGE": {
                setCustomStartDate(null);
                setCustomEndDate(null);
                handleStateChanges(true, false, false, false, true);
                break;
            }
            case "DAILY_CHOOSE_TIME_PERIOD_PREVIOUS_MONTH": {
                const tempEndDate = moment()
                    .subtract(1, "months")
                    .endOf("month")
                    .format("YYYY-MM-DD");
                const tempStartDate = moment()
                    .subtract(1, "months")
                    .startOf("month")
                    .format("YYYY-MM-DD");
                handleStateChanges(false, false, false, false, false, tempStartDate, tempEndDate);
                usageServiceGraphData(tempStartDate, tempEndDate, "D2BD");
                break;
            }
            case "MONTHLY_CHOOSE_TIME_PERIOD_LAST_12_MONTHS": {
                const tempEndDate = moment(current).format("YYYY-MM-DD");
                const tempStartDate = moment(current)
                    .subtract(12, "month")
                    .format("YYYY-MM-DD");
                handleStateChanges(false, false, false, false, false, tempStartDate, tempEndDate);
                usageServiceGraphData(tempStartDate, tempEndDate, "D2BM");
                break;
            }
            case "MONTHLY_CHOOSE_TIME_PERIOD_CURRENT_YEAR": {
                const tempEndDate = moment()
                    .endOf("year")
                    .format("YYYY-MM-DD");
                const tempStartDate = moment()
                    .startOf("year")
                    .format("YYYY-MM-DD");
                handleStateChanges(false, false, false, false, false, tempStartDate, tempEndDate);
                usageServiceGraphData(tempStartDate, tempEndDate, "D2BM");
                break;
            }
            case "MONTHLY_CHOOSE_TIME_PERIOD_PREVIOUS_YEAR": {
                const tempEndDate = moment()
                    .subtract(1, "year")
                    .endOf("year")
                    .format("YYYY-MM-DD");
                const tempStartDate = moment()
                    .subtract(1, "year")
                    .startOf("year")
                    .format("YYYY-MM-DD");
                handleStateChanges(false, false, false, false, false, tempStartDate, tempEndDate);
                usageServiceGraphData(tempStartDate, tempEndDate, "D2BM");
                break;

            }
            case "MONTHLY_CHOOSE_TIME_PERIOD_CUSTOM_RANGE": {
                setCustomStartDate(null);
                setCustomEndDate(null);
                handleStateChanges(false, true, false, false, true);
                break;
            }
            case "BILL_CHOOSE_TIME_PERIOD_PREVIOUS_YEAR": {
                let tempEndDate = moment()
                    .subtract(1, "year")
                    .endOf("year")
                    .format("YYYY-MM-DD");
                let tempStartDate = moment()
                    .subtract(1, "year")
                    .startOf("year")
                    .format("YYYY-MM-DD");
                handleStateChanges(false, false, false, true, false, tempStartDate, tempEndDate);
                usageBillingHistoryDetails(tempEndDate, tempStartDate)
                break;
            }
            case "BILL_CHOOSE_TIME_PERIOD_CURRENT_YEAR": {
                let tempEndDate = moment()
                    .endOf("year")
                    .format("YYYY-MM-DD");
                let tempStartDate = moment()
                    .startOf("year")
                    .format("YYYY-MM-DD");
                let end = moment()
                    .subtract(1, 'days')
                    .format("YYYY-MM-DD");
                let start = moment()
                    .startOf("year")
                    .format("YYYY-MM-DD");
                handleStateChanges(false, false, false, true, false, tempStartDate, tempEndDate);
                usageBillingHistoryDetails(end, start)
                break;
            }
            case "BILL_CHOOSE_TIME_PERIOD_LAST_12_MONTHS": {
                let tempEndDate = moment(current).format("YYYY-MM-DD");
                let tempStartDate = moment(current)
                    .subtract(11, "month")
                    .format("YYYY-MM-DD");
                handleStateChanges(false, false, false, true, false, tempStartDate, tempEndDate);
                usageBillingHistoryDetails(tempEndDate, tempStartDate)
                break;
            }
            case "BILL_CHOOSE_TIME_PERIOD_CUSTOM_RANGE": {
                setCustomStartDate(null);
                setCustomEndDate(null);
                handleStateChanges(false, false, true, true, true);
                break;
            }
            case "WEEK_CHOOSE_TIME_PERIOD_CURRENT_MONTH": {
                const tempEndDate = moment()
                    .endOf("month")
                    .format("YYYY-MM-DD");
                const tempStartDate = moment()
                    .startOf("month")
                    .format("YYYY-MM-DD");
                setHourCustomRange(false);
                setWeekCustomRange(false)
                handleStateChanges(false, false, false, false, false, tempStartDate, tempEndDate);
                usageServiceGraphData(tempStartDate, tempEndDate, "D2BW");
                break;
            }
            case "WEEK_CHOOSE_TIME_PERIOD_PREVIOUS_MONTH": {
                const tempEndDate = moment()
                    .subtract(1, "months")
                    .endOf("month")
                    .format("YYYY-MM-DD");
                const tempStartDate = moment()
                    .subtract(1, "months")
                    .startOf("month")
                    .format("YYYY-MM-DD");
                setHourCustomRange(false);
                setWeekCustomRange(false)
                handleStateChanges(false, false, false, false, false, tempStartDate, tempEndDate);
                usageServiceGraphData(tempStartDate, tempEndDate, "D2BW");
                break;
            }
            case "HOUR_CHOOSE_TIME_PERIOD_LAST_24_HOURS": {
                const tempEndDate = moment(current).format(YEAR_DATE_FORMAT);
                const tempStartDate = moment(current)
                    .subtract(1, "day")
                    .format(YEAR_DATE_FORMAT);
                const additionalIdentifiers = [
                    {
                    name: "mode",
                    value: hourlyMode
                    },
                    {
                    name: "clientTimestamp",
                    value: moment().format(TIMESTAMP_DATE_FOMRAT)
                    }
                ]
                setHourCustomRange(false);
                setWeekCustomRange(false)
                handleStateChanges(false, false, false, false, false, tempStartDate, tempEndDate);
                usageServiceGraphData(tempStartDate, tempEndDate, "D2BH", additionalIdentifiers);
                break;

            }
        }
    }


    const materialTheme = createMuiTheme({
        overrides: {
          "MuiDialogActions": {
            "root": {
              "justifyContent": "center",
              "alignItems": "start"
            }
          }
    }})
    const closePicker = () => {
        setDatePickerIsOpen(false);
    }

    const filterPeriod = (startDate, endDate) => {
        usageServiceGraphData(startDate, endDate, "D2BW")
    }

    const handleMonthPeriod = (event) => {
        setDatePickerIsOpen(false);
        let endDate = moment(event).endOf('month').format('YYYY-MM-DD');
        let startDate = moment(event).startOf('month').format('YYYY-MM-DD');
        setCustomStartDate(startDate);
        setCustomEndDate(endDate);
        setStartDate(null)
        setEndDate(null)
        filterPeriod(startDate, endDate);
    };

    const filterHourPeriod = (startDate, endDate) => {
        usageServiceGraphData(startDate, endDate, "D2BH")
    }

    const handleHourPeriod = (event) => {
        setDatePickerIsOpen(false);
        let endDate = moment(event).endOf('day').format('YYYY-MM-DD');
        let startDate = moment(event).startOf('day').format('YYYY-MM-DD');
        setCustomStartDate(startDate);
        setCustomEndDate(endDate);
        setStartDate(null);
        setEndDate(null);
        filterHourPeriod(startDate, endDate);
    };

    const handleCustomHourWeekRange = (event) => {
        if (event === "WEEK_CHOOSE_TIME_PERIOD_CUSTOM_RANGES") {
            setCustomStartDate(null);
            setCustomEndDate(null);
            handleStateChanges(false, false, false, false, false);
            setHourCustomRange(false);
            setWeekCustomRange(true)
            setDatePickerIsOpen(true);
        } else if (event === "HOUR_CHOOSE_TIME_PERIOD_CUSTOM_RANGE") {
            setCustomStartDate(null);
            setCustomEndDate(null);
            handleStateChanges(false, false, false, false, false);
            setHourCustomRange(true);
            setWeekCustomRange(false)
            setDatePickerIsOpen(true);
        }
    }

    return (
        <>
            <>
                <Grid container justify="space-between" >
                    <Grid item align="center">
                    {
                        usageTrendLabelReady ?
                        <Typography
                            align="left"
                            variant="h6"
                            className={classes.titile}
                        >
                            <strong>{labels("E_USAGE_TITLE")}</strong>
                        </Typography>
                        : <Skeleton />
                    }
                    </Grid>

                    <Grid item >
                        <DownloadReports
                            usageData={usageData?.getUsageTrends?.usageQuantity}
                            usageUom={usageData?.getUsageTrends?.usageUnit}
                            temperatureUom={usageData?.getUsageTrends?.temperatureUnit}
                            view={chooseViewDropdown?.dropDownCode}
                            startDate={startDate}
                            endDate={endDate}
                            customstartDate={customstartDate}
                            customendDate={customendDate}
                            billData={billData}
                            billView={billView}
                            formattedBillData={formattedBillData}
                            hourlyMode={hourlyMode}
                            hourCustomRange={hourCustomRange}
                        />
                    </Grid>
                </Grid>
                <Grid
                    className={classes.graphOptions}
                    container
                    direction= "row"
                    spacing={2}
                >
                        <Grid item >
                            {record && chooseViewDropdown ? (
                                <>
                                    <FormControl size="small">
                                    {
                                        usageTrendLabelReady ?
                                    <Typography variant="caption" className={classes.size}>{labels("E_DROPDOWN_CHOOSE_VIEW")}</Typography>: <Skeleton />
                                    }
                                    {
                                        record?.length === 1 ? (
                                            <Typography className={classes.chooseViewLabel}>{record[0]?.dropDownValue}</Typography>
                                        ) : 
                                        <STYLED_SELECT
                                            className={classes.styleWidth}
                                            name={chooseViewDropdown?.dropDownValue}
                                            value={chooseViewDropdown?.dropDownCode}
                                            onChange={chooseViewChange}
                                            displayEmpty={true}
                                            IconComponent={ExpandMoreSharpIcon}
                                            disableUnderline={true}
                                            MenuProps={ddlMenuProps}
                                        >
                                            {record &&
                                                record.map((item) => (
                                                    <STYLED_MENU_ITEM
                                                        size="small"
                                                        value={item?.dropDownCode}
                                                        className="text-field"
                                                        key={item?.dropDownCode}
                                                    >
                                                        {item?.dropDownValue}
                                                    </STYLED_MENU_ITEM>
                                                ))}
                                        </STYLED_SELECT>
                                    }
                                    </FormControl>
                                </>
                            ) : (
                                <Skeleton />
                            )}{" "}
                        </Grid>
                        <Grid item >
                            {records && choosetimePeriodDropdown ? (
                                <>
                                    <FormControl size="8vh">
                                    {
                                        usageTrendLabelReady ?
                                    <Typography variant="caption" className={classes.size}>{labels("E_DROPDOWN_CHOOSE_TIME_PERIOD")}</Typography>
                                    : <Skeleton />
                                    }
                                        <STYLED_SELECT
                                            name={choosetimePeriodDropdown?.dropDownValue}
                                            value={choosetimePeriodDropdown?.dropDownCode}
                                            onChange={timePeriodChange}
                                            displayEmpty={true}
                                            IconComponent={ExpandMoreSharpIcon}
                                            disableUnderline={true}
                                            MenuProps={ddlMenuProps}
                                            width="30vh"
                                        >
                                            {records &&
                                                records.map((i) => (
                                                    <STYLED_MENU_ITEM
                                                        value={i?.dropDownCode}
                                                        className="text-field"
                                                        key={i?.dropDownCode}
                                                        onClick={(event) => handleCustomHourWeekRange(i?.dropDownCode)}
                                                    >
                                                        {i.dropDownValue}
                                                    </STYLED_MENU_ITEM>
                                                ))}
                                        </STYLED_SELECT>
                                    </FormControl>
                                </>
                            ) : (
                                <Skeleton />
                            )}{" "}
                        </Grid>
                        {!isMobile && showDateRange.startDate && showDateRange.endDate ?(<Grid item className={classes.dataRange}>
        <Grid container direction="rows" justify="center">
        {
            usageTrendLabelReady ?
            <Typography variant="subtitle2" >
                  <span>{showDateRange.startDate} - {showDateRange.endDate}</span> <span>  {labels("E_TOTAL_USAGE")} {commonService.Numberwithcommas(Number(parseFloat(totalHourlyData)).toFixed(2))} {labels("E_HOURLY_UNITS")}</span>
                  </Typography> : <Skeleton />
        }
                  </Grid>
             </Grid>):null}
                </Grid>
                {isMobile && showDateRange?.startDate && showDateRange?.endDate ?(<Grid item className={classes.dataRange}>
        <Grid container justify="center">
        {
            usageTrendLabelReady ?
        <Typography variant="subtitle2" >
                  <span>{showDateRange?.startDate} - {showDateRange?.endDate}</span><span>  {labels("E_TOTAL_USAGE")} {commonService.Numberwithcommas(Number(parseFloat(totalHourlyData)).toFixed(2))} {labels("E_HOURLY_UNITS")}</span>
                  </Typography> : <Skeleton />
        }
        </Grid>
             </Grid>):null}
                <>
                    {customRange || monthCustomRange || billCustomRange ? (
                        <MaterialUIPickers
                            saId={saId}
                            accountId={accountId}
                            customstartDate={customstartDate}
                            customendDate={customendDate}
                            saStartDate={saStartDate}
                            handleDateChange={handleDateChange}
                            handleEndDateChange={handleEndDateChange}
                            monthCustomRange={monthCustomRange}
                        />
                    ) : weekCustomRange ?
                        (<MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <ThemeProvider theme={materialTheme}>
                                <DatePicker
                                    disableFuture
                                    openTo="year"
                                    maxDate={moment()}
                                    minDate={moment(saStartDate)}
                                    inputVariant="standard"
                                    open={datePickerIsOpen}
                                    TextFieldComponent={() => null}
                                    cancelLabel={<span onClick={closePicker}>{highestUsageLabelReady && Labels("HIGHEST_USAGE_CANCEL")}</span>}
                                    views={["year", "month"]}
                                    onChange={handleMonthPeriod}
                                    saId={saId}
                                    accountId={accountId}
                                    customstartDate={customstartDate}
                                    customendDate={customendDate}
                                /> </ThemeProvider>
                        </MuiPickersUtilsProvider>)
                        : hourCustomRange ?
                            (<MuiPickersUtilsProvider utils={DateFnsUtils} >
                                <ThemeProvider theme={materialTheme}>
                                    <DatePicker
                                        disableFuture
                                        openTo="date"
                                        maxDate={moment()}
                                        minDate={moment(saStartDate)}
                                        inputVariant="standard"
                                        open={datePickerIsOpen}
                                        TextFieldComponent={() => null}
                                        cancelLabel={<span onClick={closePicker}>{highestUsageLabelReady && Labels("HIGHEST_USAGE_CANCEL")}</span>}
                                        views={["year", "month", "date"]}
                                        onChange={handleHourPeriod}
                                    /> </ThemeProvider>
                            </MuiPickersUtilsProvider>) : null}
                </>
            </>
            <>
                {graphLoading ? <GraphLoader /> : null}
                {!graphLoading && (usageData || billData)  ? (
                    <div align="center" className={`margin-top-10 ${classes.overlayParent}`}>
                        <ChartTest
                            height={props.height}
                            width={props.width}
                            data={billView ? formattedBillData : formattedUsageData}
                            units={billView ? billData?.[0]?.currency : usageData?.getUsageTrends?.usageUnit}
                            labels={labels}
                            labelReady={usageTrendLabelReady}
                            billView={billView}
                        >
                        </ChartTest>
                        {overlay
                            ? <Typography variant="subtitle1" className={classes.overlayClass}>{usageTrendLabelReady ? labels("E_OVERLAY_CHOOSE_DATE_RANGE") : <Skeleton />}</Typography>
                            : (noDataOverlay ? <Typography variant="subtitle1" className={classes.overlayClass}>{usageTrendLabelReady ? `0 ${usageUnit} ${labels("E_OVERLAY_CONSUMED")}` :<Skeleton />}</Typography> : null)}
                    </div>
                ) : graphLoading ? null :
                    (<Grid align="center" className={classes.des}>
                        {meterLogo && (MeterImage && (
                            <img
                                height="180px"
                                src={MeterImage?.assetPath}
                                alt={
                                    MeterImage
                                        ? labels[MeterImage?.ELECTRICITY_PILLAR_IMAGE]
                                        : ''
                                }
                            />
                        ))}
                        {
                            usageTrendLabelReady ?
                        <Typography align="center" variant="subtitle2">{labels("E_ERROR")}</Typography>
                        : <Skeleton />
                        }
                    </Grid>
                    )}
                    <div style={{textAlign:'center',fontStyle:'italic'}}>
                    {
                      !graphLoading &&chooseViewDropdown && chooseViewDropdown.dropDownCode=="USAGE_DROPDOWN_DAILY_VIEW" ? <Typography variant="caption">{labels("E_USAGE_NOTE")}</Typography>:""
                    }
                    </div>
            </>
        </>
    );
}
